import { css, styled } from '@mui/material';

import ActionBarSkeleton from '../ActionBarSkeleton/ActionBarSkeleton';
import TableSkeleton from '../TableSkeleton/TableSkeleton';
import { dataTableSkeletonClasses } from './theme';

import type { DataTableSkeletonOwnerState, DataTableSkeletonProps } from './types';

export default function DataTableSkeleton(props: DataTableSkeletonProps) {
  const {
    actionBarProps,
    showActionBar = true,
    showSideBorder = false,
    showSideMargin = false,
    tableProps,
    ...others
  } = props;

  const ownerState: DataTableSkeletonOwnerState = {
    ...props,
    showActionBar,
    showSideBorder,
    showSideMargin,
  };

  return (
    <DataTableSkeletonRoot {...others} ownerState={ownerState}>
      {showActionBar && (
        <DataTableSkeletonActionBar
          showSideMargin={showSideMargin}
          {...actionBarProps}
          ownerState={ownerState}
        />
      )}
      <DataTableSkeletonTable
        showSideMargin={showSideMargin}
        {...tableProps}
        ownerState={ownerState}
      />
    </DataTableSkeletonRoot>
  );
}

const DataTableSkeletonRoot = styled('div', {
  target: dataTableSkeletonClasses.root,
})<{ ownerState: DataTableSkeletonOwnerState }>(
  ({ theme, ownerState }) => css`
    max-width: 100%;
    overflow-x: hidden;

    ${ownerState.showSideBorder &&
    css`
      border-left: ${theme.mixins.border('border/weaker/default')};
      border-right: ${theme.mixins.border('border/weaker/default')};
    `}
  `,
);

const DataTableSkeletonActionBar = styled(ActionBarSkeleton, {
  target: dataTableSkeletonClasses.actionBar,
})<{ ownerState: DataTableSkeletonOwnerState }>(() => css``);

const DataTableSkeletonTable = styled(TableSkeleton, {
  target: dataTableSkeletonClasses.table,
})<{ ownerState: DataTableSkeletonOwnerState }>(() => css``);
